import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { decodeQuery } from '@swf/core/utils';

const useCMSHeaderAndGridLayout = () => {
  const [query] = Object.keys(useSelector(select.location.getQuery));
  const depositResultContext = query && decodeQuery(query);
  const isStandaloneRmf = useSelector(select.location.isStandAloneRMF);
  const isStandAloneRmfMandatory = useSelector(select.account.isStandAloneRmfMandatory);

  const cmsHeaderAndGridLayout =
    isStandaloneRmf ||
    !depositResultContext ||
    depositResultContext.cmsHeaderAndGridLayout === true ||
    depositResultContext.cmsHeaderAndGridLayout === 'true';

  return isStandAloneRmfMandatory ? false : cmsHeaderAndGridLayout;
};

export default useCMSHeaderAndGridLayout;
